// Account screens still served by the original CRA pages (proxied by the Next.js
// site). Navigating to them reloads the document so the site stylesheet does
// not leak into those screens.
export const LEGACY_PATHS = [
  "/register",
  "/forgotpassword",
  "/passwordreset",
  "/verify-account",
  "/delete-account",
  "/jamestown-wallet",
  "/bill-payment",
];

export function isLegacyPath(href: string) {
  const path = href.split(/[?#]/)[0];
  return LEGACY_PATHS.includes(path);
}
